import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

import LoadingOverlay from '../components/features/loading-overlay'
// import SidebarProduct from '../components/pages/products/sidebar';
// import Sidebar from '../components/pages/shop/sidebar';
import { scrollTop } from '../utils'

const ProductDetail = React.lazy('../components/pages/products/default')
const ElementPages = React.lazy(() => import('./elements-route.js'))
const ProductPages = React.lazy(() => import('./products-route.js'))
const ShopPages = React.lazy(() => import('./shop-route.js'))
const BlogPages = React.lazy(() => import('./blogs-route.js'))
const OtherPages = React.lazy(() => import('./others-route.js'))
const HomePage = React.lazy(() => import('./home-route.js'))
const AuthPage = React.lazy(() => import('./auth-route.js'))

export default function AppRoot() {
  useEffect(() => {
    scrollTop()
  }, [])

  return (
    <React.Suspense fallback={<LoadingOverlay />}>
      <Switch>
        {/* <Route exact path={ `${process.env.PUBLIC_URL}/explore` } component={ ExplorePage} /> */}

        <Route
          path={`${process.env.PUBLIC_URL}/elements`}
          component={ElementPages}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/product`}
          component={ProductPages}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/product/default`}
          component={ProductDetail}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/products`}
          component={ShopPages}
        />
        
        <Route path={`${process.env.PUBLIC_URL}/shop`} component={ShopPages} />
        <Route path={`${process.env.PUBLIC_URL}/blog`} component={BlogPages} />
        <Route
          path={`${process.env.PUBLIC_URL}/pages`}
          component={OtherPages}
        />
        <Route path={`${process.env.PUBLIC_URL}/auth`} component={AuthPage} />
        <Route path={`${process.env.PUBLIC_URL}/`} component={HomePage} />
      </Switch>
    </React.Suspense>
  )
}
